import constant from '../constant'

/**
 * True when the logged-in user's designation holds `permissionId`.
 *
 * The module list is the base64 blob login writes to sessionStorage — the same
 * source Router.js reads for route-level gating. This is UI convenience only;
 * every gated action is also enforced by the API.
 */
export const hasPermission = (permissionId) => {
    try {
        const stored = sessionStorage.getItem(constant.keys.userModule)
        if (!stored) return false

        const modules = JSON.parse(atob(JSON.parse(stored)))
        return Array.isArray(modules) && modules.some((mod) => mod.PERMISSION_ID === permissionId)
    } catch (error) {
        // A corrupt/absent blob means "cannot prove permission" — hide the action.
        return false
    }
}

export default hasPermission
